import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import ProposteRankingTableSet from "./ProposteRanking.TableSet";
import ProposteAnalisiKPISet from "../proposteAnalisi/ProposteAnalisi.KPISet";

const ProposteRanking = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showProposteRanking = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Proposte')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <ProposteAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showProposteRanking &&
                <ProposteRankingTableSet dataProviderName={dataProviderName} filters={filters} />
            }
        </Box>
    )
}

export default ProposteRanking;
